// Store names Optimus derives a contact from: SkynetCore `SystemContactTypeSource` plus `Borrower`.
// CRM persists the same names as `Contact.OriginKind`, SkynetAPI returns them as `sourceKind` on
// /contacts/v2, and SkynetAUS echoes them on the DRIVE preview.
export const ContactSourceKind = {
  BORROWER: 'Borrower',
  LOAN_FILE_CONTACT: 'LoanFileContact',
  LOAN_ROLE: 'LoanRole',
  LENDER: 'Lender',
  SELLER: 'Seller',
  AGENT: 'Agent',
  REALTOR: 'Realtor',
  CLOSING_COMPANY: 'ClosingCompany',
  TITLE_HOLDER: 'TitleHolder',
  NON_BORROWING_ENTITY: 'NonBorrowingEntity',
  SUB_COMPANY: 'SubCompany',
  ASSET: 'Asset',
  MORTGAGE_INSURANCE: 'MortgageInsurance',
  APPRAISAL: 'Appraisal',
  INSPECTION: 'Inspection',
  INSURANCE: 'Insurance',
};

export const CONTACT_SOURCE_LABELS = {
  [ContactSourceKind.BORROWER]: 'Borrowers',
  [ContactSourceKind.LOAN_FILE_CONTACT]: 'Loan file',
  [ContactSourceKind.LOAN_ROLE]: 'Loan roles',
  [ContactSourceKind.LENDER]: 'Lender',
  [ContactSourceKind.SELLER]: 'Agent & seller',
  [ContactSourceKind.AGENT]: 'Agent & seller',
  [ContactSourceKind.REALTOR]: 'Realtor portal',
  [ContactSourceKind.CLOSING_COMPANY]: 'Closing',
  [ContactSourceKind.TITLE_HOLDER]: 'Title holders',
  [ContactSourceKind.NON_BORROWING_ENTITY]: 'Non-borrowers',
  [ContactSourceKind.SUB_COMPANY]: 'Sub-company',
  [ContactSourceKind.ASSET]: 'Assets',
  [ContactSourceKind.MORTGAGE_INSURANCE]: 'Mortgage insurance',
  [ContactSourceKind.APPRAISAL]: 'Appraisal',
  [ContactSourceKind.INSPECTION]: 'Inspection',
  [ContactSourceKind.INSURANCE]: 'Insurance',
};

export const ContactGroup = {
  BORROWERS_AND_LEADS: 'borrowers-and-leads',
  ORIGINATION_TEAM: 'origination-team',
  REAL_ESTATE: 'real-estate',
  TITLE_AND_CLOSING: 'title-and-closing',
  APPRAISAL: 'appraisal',
  BROKERS_AND_LENDERS: 'brokers-and-lenders',
  OTHER: 'other',
};

export const CONTACT_GROUP_LABELS = {
  [ContactGroup.BORROWERS_AND_LEADS]: 'Borrowers & leads',
  [ContactGroup.ORIGINATION_TEAM]: 'Origination team',
  [ContactGroup.REAL_ESTATE]: 'Real estate',
  [ContactGroup.TITLE_AND_CLOSING]: 'Title & closing',
  [ContactGroup.APPRAISAL]: 'Appraisal',
  [ContactGroup.BROKERS_AND_LENDERS]: 'Brokers & lenders',
  [ContactGroup.OTHER]: 'Other',
};

export const CONTACT_GROUP_ORDER = [
  ContactGroup.BORROWERS_AND_LEADS,
  ContactGroup.ORIGINATION_TEAM,
  ContactGroup.REAL_ESTATE,
  ContactGroup.TITLE_AND_CLOSING,
  ContactGroup.APPRAISAL,
  ContactGroup.BROKERS_AND_LENDERS,
  ContactGroup.OTHER,
];

export const SOURCE_KIND_GROUPS = {
  [ContactSourceKind.BORROWER]: ContactGroup.BORROWERS_AND_LEADS,
  [ContactSourceKind.LOAN_ROLE]: ContactGroup.ORIGINATION_TEAM,
  [ContactSourceKind.AGENT]: ContactGroup.REAL_ESTATE,
  [ContactSourceKind.REALTOR]: ContactGroup.REAL_ESTATE,
  [ContactSourceKind.SELLER]: ContactGroup.REAL_ESTATE,
  [ContactSourceKind.CLOSING_COMPANY]: ContactGroup.TITLE_AND_CLOSING,
  [ContactSourceKind.TITLE_HOLDER]: ContactGroup.TITLE_AND_CLOSING,
  [ContactSourceKind.APPRAISAL]: ContactGroup.APPRAISAL,
  [ContactSourceKind.INSPECTION]: ContactGroup.APPRAISAL,
  [ContactSourceKind.SUB_COMPANY]: ContactGroup.BROKERS_AND_LENDERS,
  [ContactSourceKind.LENDER]: ContactGroup.BROKERS_AND_LENDERS,
  [ContactSourceKind.LOAN_FILE_CONTACT]: ContactGroup.OTHER,
  [ContactSourceKind.NON_BORROWING_ENTITY]: ContactGroup.OTHER,
  [ContactSourceKind.ASSET]: ContactGroup.OTHER,
  [ContactSourceKind.MORTGAGE_INSURANCE]: ContactGroup.OTHER,
  [ContactSourceKind.INSURANCE]: ContactGroup.OTHER,
};

// A loan-file contact carries the system key of the type it was given, which places it better
// than its generic LoanFileContact source would.
export const SYSTEM_KEY_PREFIX_GROUPS = [
  { prefix: 'loan_role.', group: ContactGroup.ORIGINATION_TEAM },
  { prefix: 'import.loan_originator', group: ContactGroup.ORIGINATION_TEAM },
  { prefix: 'agent.', group: ContactGroup.REAL_ESTATE },
  { prefix: 'realtor.', group: ContactGroup.REAL_ESTATE },
  { prefix: 'seller', group: ContactGroup.REAL_ESTATE },
  { prefix: 'closing.', group: ContactGroup.TITLE_AND_CLOSING },
  { prefix: 'title_holder', group: ContactGroup.TITLE_AND_CLOSING },
  { prefix: 'appraisal.', group: ContactGroup.APPRAISAL },
  { prefix: 'inspection.', group: ContactGroup.APPRAISAL },
  { prefix: 'sub_company.', group: ContactGroup.BROKERS_AND_LENDERS },
  { prefix: 'lender', group: ContactGroup.BROKERS_AND_LENDERS },
  { prefix: 'import.loan_origination_company', group: ContactGroup.BROKERS_AND_LENDERS },
];
